import * as yup from 'yup';

export type SearchDto = {
  searchValue: string;
};

export const searchSchema: yup.SchemaOf<SearchDto> = yup.object({
  searchValue: yup.string().default('').required(),
});
